import { useState } from "react";
import { useQuery } from "@apollo/client";
import { GetEmployeeRewardsQuery, GetEmployeeRewardsQueryVariables } from "generated/graphql";
import queries from "Shared/queries";

export const EMPLOYEE_REWARDS_PER_PAGE = 10;

export const useEmployeeRewards = (employeeProfileId: string) => {
  const [page, setPage] = useState(1);
  const { data, loading, error, refetch } = useQuery<
    GetEmployeeRewardsQuery,
    GetEmployeeRewardsQueryVariables
  >(queries.GET_EMPLOYEE_REWARDS, {
    variables: {
      employeeProfileId,
      page,
      perPage: EMPLOYEE_REWARDS_PER_PAGE,
    },
    fetchPolicy: "cache-and-network",
  });

  const refetchQueries = () => {
    refetch({ page, employeeProfileId });
  };

  const onChangePage = (
    evt: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => setPage(newPage);

  return {
    employeeRewards: data?.employeeProfile.employee.rewards,
    loading,
    error,
    refetchQueries,
    page,
    onChangePage,
    perPage: EMPLOYEE_REWARDS_PER_PAGE,
  };
};
